import { Radio, Select, Spin } from 'antd';
import { T } from 'react-translator-component';

const { Option } = Select;

export type IdentificationType = 'OCPP_TAG' | 'DOCUMENT';

interface TagItem {
  ocpp_id_tag: string;
  user_pk?: string | number;
  user_name?: string;
  email?: string;
  doc_type?: string;
  doc_number?: string;
}

interface SearchOcppTagOrDocumentProps {
  identificationType: IdentificationType;
  onIdentificationTypeChange: (value: IdentificationType) => void;
  selectedTagValue?: string;
  onSelectedTagChange: (value: string | undefined) => void;
  selectedDocumentValue?: string;
  onSelectedDocumentChange: (value: string | undefined) => void;
  tagsList: TagItem[];
  fetching: boolean;
  onSearch: (value: string) => void;
  label?: string;
  disabled?: boolean;
}

const SearchOcppTagOrDocument = ({
  identificationType,
  onIdentificationTypeChange,
  selectedTagValue,
  onSelectedTagChange,
  selectedDocumentValue,
  onSelectedDocumentChange,
  tagsList,
  fetching,
  onSearch,
  label = T('Identification Type'),
  disabled = false,
}: SearchOcppTagOrDocumentProps) => {
  return (
    <>
      <span>{label}:</span>

      <Radio.Group
        value={identificationType}
        disabled={disabled}
        onChange={(e) => {
          onSelectedTagChange(undefined);
          onSelectedDocumentChange(undefined);
          onIdentificationTypeChange(e.target.value);
        }}
      >
        <Radio value='OCPP_TAG'>{T('Ocpp ID Tag')}</Radio>
        <Radio value='DOCUMENT'>{T('Document')}</Radio>
      </Radio.Group>

      {identificationType === 'OCPP_TAG' ? (
        <>
          <span>OCPP ID Tag:</span>
          <Select
            showSearch
            disabled={disabled}
            value={selectedTagValue}
            onChange={(value) => {
              onSelectedTagChange(value);
            }}
            placeholder={T('Search to Select')}
            onSearch={onSearch}
            notFoundContent={
              fetching ? <Spin size='small' /> : T('No results found')
            }
            filterOption={false}
          >
            {tagsList?.length > 0 &&
              tagsList.map((tag) => (
                <Option key={tag.ocpp_id_tag} value={tag.ocpp_id_tag}>
                  {tag.user_pk
                    ? `${tag.user_name} - ${tag.email} - ${tag.ocpp_id_tag}`
                    : tag.ocpp_id_tag}
                </Option>
              ))}
          </Select>
        </>
      ) : (
        <>
          <span>{T('Document')}:</span>
          <Select
            showSearch
            disabled={disabled}
            value={selectedDocumentValue}
            onChange={(value) => {
              onSelectedDocumentChange(value);
            }}
            placeholder={T('Search to Select')}
            onSearch={onSearch}
            notFoundContent={
              fetching ? <Spin size='small' /> : T('No results found')
            }
            filterOption={false}
          >
            {tagsList?.length > 0 &&
              tagsList
                .filter(
                  (item) =>
                    typeof item.doc_type === 'string' &&
                    typeof item.doc_number === 'string',
                )
                .map((user) => (
                  <Option key={user.user_pk} value={user.ocpp_id_tag}>
                    {`${user.doc_type} - ${user.doc_number}`}
                  </Option>
                ))}
          </Select>
        </>
      )}
    </>
  );
};

export default SearchOcppTagOrDocument;